"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
const v0 = (0, utils_1.buildTypes)({
    types: {
        RoleId: "u64",
        Role: {
            created: "WhoAndWhen",
            updated: "Option<WhoAndWhen>",
            id: "RoleId",
            space_id: "SpaceId",
            disabled: "bool",
            expires_at: "Option<BlockNumber>",
            content: "Content",
            permissions: "SpacePermissionSet",
        },
        RoleUpdate: {
            disabled: "Option<bool>",
            content: "Option<Content>",
            permissions: "Option<SpacePermissionSet>",
        },
    }
});
exports.default = [v0];
